var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-2" },
    [
      !_vm.editing
        ? [
            _vm._t("label", function () {
              return [
                !_vm.hideLabel
                  ? _c("v-list-item-title", {}, [
                      _vm._v(_vm._s(_vm.label) + ":"),
                    ])
                  : _vm._e(),
              ]
            }),
            _vm._t("value", function () {
              return [_c("span", [_vm._v(_vm._s(_vm.valueModel))])]
            }),
          ]
        : [
            _vm._t("edit", function () {
              return [
                _c("v-text-field", {
                  attrs: { label: _vm.label, dense: "" },
                  model: {
                    value: _vm.valueModel,
                    callback: function ($$v) {
                      _vm.valueModel = $$v
                    },
                    expression: "valueModel",
                  },
                }),
              ]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }